<template>
  <b-row class="mb-1">
    <b-col cols="4" class="pr-0">
      <b-input-group>
        <b-form-select
          v-model="projection.crop"
          :options="options"
          placeholder="Crop Type"
          :state="!$v.projection.crop.$invalid"
          invalid-feedback="Required"
          @change="
            value => handleProjectionUpdate({ update: value, field: 'crop' })
          "
        ></b-form-select>
      </b-input-group>
    </b-col>
    <b-col cols="4" class="pr-0">
      <b-input-group>
        <b-form-input
          v-model="projectionYield"
          type="number"
          placeholder="Yield Desired"
          :state="!$v.projectionYield.$invalid"
          invalid-feedback="Required"
        ></b-form-input>
      </b-input-group>
    </b-col>
    <b-col cols="2" class="pr-0">
      <b-input-group>
        <b-form-input disabled v-model="unit" placeholder="Unit"></b-form-input>
      </b-input-group>
    </b-col>
    <b-col cols="2">
      <b-button-group aling-h="center">
        <b-button
          v-if="projectionListLength === +index + 1"
          variant="success"
          @click="addProjection"
          ><i class="fa fa-plus"></i
        ></b-button>
        <b-button
          v-if="projectionListLength > 1"
          variant="danger"
          @click="removeProjection"
          ><i class="fa fa-trash"></i
        ></b-button>
      </b-button-group>
    </b-col>
  </b-row>
</template>

<script>
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  name: "SoilCropForm",
  mixins: [validationMixin, ToastNotifications],
  props: {
    projection: {
      type: Object,
      default: () => {
        return {};
      }
    },
    options: {
      type: Array,
      default: () => []
    },
    projectionListLength: {
      type: Number,
      default: null
    },
    index: {
      type: Number,
      default: null
    }
  },
  computed: {
    projectionYield: {
      get() {
        return this.projection.yield;
      },
      set(value) {
        this.handleProjectionUpdate({ update: Number(value), field: "yield" });
      }
    },
    unit() {
      return this.projection.unit;
    }
  },
  validations: {
    projectionYield: { required },
    projection: {
      crop: { required }
    }
  },
  methods: {
    handleProjectionUpdate({ update, field }) {
      this.$emit("updateProjection", { update, field, index: this.index });
    },
    addProjection() {
      this.$emit("updateProjectionList", {
        index: this.index,
        action: "add"
      });
    },
    removeProjection() {
      this.$emit("updateProjectionList", {
        index: this.index,
        action: "remove"
      });
    }
  }
};
</script>
